import React, { useState } from 'react'
import { featuredImgRef } from '../../firebase'
import { Form, Button, Alert, FormCheck } from 'react-bootstrap';
import { useFileInput } from '../../hooks/useFileInput';
import { ref, uploadBytes } from 'firebase/storage';

export default function UploadFeaturedImage() {
    // console.log(featuredImgRef);

    const [check1, setCheck1] = useState(false)
    const [check2, setCheck2] = useState(false)
    const [check3, setCheck3] = useState(false)
    const [msg, setMsg] = useState()
    const [file1, setFile1] = useFileInput()
    const [file2, setFile2] = useFileInput()
    const [file3, setFile3] = useFileInput()
    const uploadFeaturedImage = async (e)=>{
        e.preventDefault()
        const img1Ref = ref(featuredImgRef, "img1");
        const img2Ref = ref(featuredImgRef, "img2");
        const img3Ref = ref(featuredImgRef, "img3");
        check1 && await uploadBytes(img1Ref, file1);
        check2 && await uploadBytes(img2Ref, file2);
        check3 && await uploadBytes(img3Ref, file3);
        setMsg("Upload Successful")
    }


  return (
    <>
        <h1>Upload Featured Photos</h1>
        {msg && <Alert variant='success'>{msg}</Alert>}
        <Form className='mb-5' onSubmit={uploadFeaturedImage}>
            <Form.Group className='mb-4'>
                <div className='d-flex'>
                    <Form.Label>FeaturedImage 1</Form.Label>
                    <FormCheck className='ms-2' checked={check1} onClick={(e)=>check1 ? setCheck1(false) : setCheck1(true)}></FormCheck>
                </div>
                <Form.Control type='file' disabled={check1 ? false : true} onChange={setFile1}></Form.Control>
            </Form.Group>
            <Form.Group className='mb-4'>
                <div className='d-flex'>
                    <Form.Label>FeaturedImage 2</Form.Label>
                    <FormCheck className='ms-2' checked={check2} onClick={(e)=>check2 ? setCheck2(false) : setCheck2(true)}></FormCheck>
                </div>
                <Form.Control type='file' disabled={check2 ? false : true} onChange={setFile2}></Form.Control>
            </Form.Group>
            <Form.Group className='mb-4'>
                <div className='d-flex'>
                    <Form.Label>FeaturedImage 3</Form.Label>
                    <FormCheck className='ms-2' checked={check3} onClick={(e)=>check3 ? setCheck3(false) : setCheck3(true)}></FormCheck>
                </div>
                <Form.Control type='file' disabled={check3 ? false : true} onChange={setFile3}></Form.Control>
            </Form.Group>
            <Button type='submit'>Upload</Button>
        </Form>
    </>
  )
}
